var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"float-start"},[_c('RoundImage',{attrs:{"src":_vm.org.logo,"alt":'Logo ' + _vm.org.name,"width":24}})],1),_c('div',{staticClass:"org-name"},[_vm._v(" "+_vm._s(_vm.org.name)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }